import { useTranslation } from 'react-i18next';

import { Dialog } from '@headlessui/react';

import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';

import CloseIcon from 'assets/png/close-icon-blue.png?format=webp;avif&as=picture';

import { AdditionalSettingsModalContent } from './additional-settings-modal-content';

interface AdditionalSettingsModalProps {
  onClose: () => void;
}

export const AdditionalSettingsModal = ({ onClose }: AdditionalSettingsModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/50" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="max-h-[90vh] w-full max-w-md overflow-y-auto rounded-[2rem] border-2 border-indigo bg-[#080540] px-4 py-2 text-white lg:p-6">
          <Dialog.Title className="mb-9 flex text-center text-base font-bold text-white lg:text-[24px]">
            <p className="gradient-title flex-1">
              {t('modals.additionalSettings.additionalSettingsTitle')}
            </p>
            <button onClick={onClose} data-testid="close-settings-button">
              <OptimizedImage
                imageData={CloseIcon}
                alt="Close"
                className="h-8 w-8 transition hover:rotate-180 hover:scale-110"
              />
            </button>
          </Dialog.Title>
          <AdditionalSettingsModalContent onClose={onClose} isMobile={false} />
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};
